import {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const navigation = [
        { name: 'Home', href: '/' },
        { name: 'Product', href: '/product' },
        { name: 'Virtual Walkthrough', href: '/virtual-walkthrough-services' },
        { name: '3D Renderings', href: '/3d-rendering-services' },
        { name: 'Pricing', href: '/pricing' },
        { name: 'Contact', href: '/contact' }
        // { name: 'The Art Room', href: '/tours/art-room' },
      ];
    
      return (
        <header className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-24">
              <div className="flex items-center">
                <Link to="/" className="flex-shrink-0">
                  <img
                    className="h-20 mt-4 w-auto"
                    src="/logo300.png"
                    alt="Logo"
                  />
                </Link>
              </div>
    
              {/* Desktop menu */}
              <nav className="hidden md:flex space-x-8">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`inline-flex items-center px-1 pt-1 text-sm font-medium ${
                      location.pathname === item.href
                        ? 'text-brand'
                        : 'text-brand-dark hover:text-brand'
                    }`}
                  >
                    {item.name}
                  </Link>
                ))}
              </nav>
    
              {/* Mobile menu button */}
              <div className="md:hidden flex items-center">
                <button
                  onClick={() => setIsMenuOpen(!isMenuOpen)}
                  className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
                  aria-label="Toggle menu"
                  aria-expanded={isMenuOpen}
                >
                  <svg
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                </button>
              </div>
            </div>
    
            {/* Mobile menu */}
            {isMenuOpen && (
              <div className="md:hidden">
                <div className="pt-2 pb-3 space-y-1">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`block pl-3 pr-4 py-2 text-base font-medium ${
                        location.pathname === item.href
                          ? 'text-blue-600 bg-blue-50'
                          : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                      }`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </header>
      );
    }
    
    export default Header;